import { render, staticRenderFns } from "./DetallesDelPlan.vue?vue&type=template&id=fa0637ba&scoped=true"
import script from "./DetallesDelPlan.vue?vue&type=script&lang=js"
export * from "./DetallesDelPlan.vue?vue&type=script&lang=js"
import style0 from "./DetallesDelPlan.vue?vue&type=style&index=0&id=fa0637ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0637ba",
  null
  
)

export default component.exports